export const PAYER_TYPE = {
    INDIVIDUAL: "Individual",
    BUSINESS: "Business",
    SSN: "SSN",
    EIN: "EIN",
}

export const RECIPIENT_ID_TYPE = {
    INDIVIDUAL: "Individual",
    BUSINESS: "Business",
    SSN: "SSN",
    EIN: "EIN",
}

export const FORM_STEP = {
    FEDERAL: "FEDERAL",
    STATE: "STATE",
    BASIC: "BASIC",
    OPTIONAL: "OPTIONAL",
    OTHER: "OTHER",
    STATEPAYROLL: "STATEPAYROLL"
}

export const FORMDATA_KEYS = {
    SKIP_KEYS: [],
}

export const FORM_VIEWS = {
    STEPPERVIEW: "STEPPERVIEW",
    IRSVIEW: "IRSVIEW",
    SUPPORTEDVIEWS: "SupportedViews",
}

export const CREATE_FORMS_LOADING_STATES = {
    SELECT_YEAR_LOADING: "SELECT_YEAR_LOADING",
    SELECT_YEAR_READY: "SELECT_YEAR_READY",
    GET_FORM_CONFIGURATIONS_PAGE_LOADING: "GET_FORM_CONFIGURATIONS_PAGE_LOADING",
    GET_FORM_CONFIGURATIONS_PAGE_READY: "GET_FORM_CONFIGURATIONS_PAGE_READY",
    PAYER_PAGE_LOADING: "PAYER_PAGE_LOADING",
    PAYER_PAGE_READY: "PAYER_PAGE_READY",
    RECIPIENT_PAGE_LOADING: "RECIPIENT_PAGE_LOADING",
    RECIPIENT_PAGE_READY: "RECIPIENT_PAGE_READY",
    DEPENDENT_FIELD_CHANGE_LOADING: "DEPENDENT_FIELD_CHANGE_LOADING",
    DEPENDENT_FIELD_CHANGE_READY: "DEPENDENT_FIELD_CHANGE_READY",
    SAVING_FORM_LOADING: "SAVING_FORM_LOADING",
    SAVING_FORM_READY: "SAVING_FORM_READY",
    SELECT_STATES_LOADING:"SELECT_STATES_LOADING",
    SELECT_STATES_READY: "SELECT_STATES_READY",
    SELECT_STATE_PAYROLL_FORMS_LOADING:"SELECT_STATE_PAYROLL_FORMS_LOADING",
    SELECT_STATE_PAYROLL_FORMS_READY: "SELECT_STATE_PAYROLL_FORMS_READY",
}

export const CREATE_FORM_STATES_MESSAGE_MAP = {
    [CREATE_FORMS_LOADING_STATES.SELECT_YEAR_LOADING]: "",
    [CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING]: "",
    [CREATE_FORMS_LOADING_STATES.PAYER_PAGE_LOADING]: "",
    [CREATE_FORMS_LOADING_STATES.RECIPIENT_PAGE_LOADING]: "",
    [CREATE_FORMS_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING]: "",
    [CREATE_FORMS_LOADING_STATES.SAVING_FORM_LOADING]: "",    
}

export const CREATE_FORM_BUTTONS_FLAGS ={
    FOR1099_FORMS : "1099s",
    FORSTATEPAYROLL_FORMS : "PAYROLLS"   
  }

export const RECORDS_TO_SHOW_PER_PAGE = 20;